import React, { Fragment } from "react";

// plugin imports
import {
	Link,
	Trans,
	useI18next,
	useTranslation,
} from "@herob191/gatsby-plugin-react-i18next";
import { AnimatePresence, motion } from "motion/react";

// style imports
import "./navMenu.scss";

// component imports
import { LayoutContext } from "../../../context/layoutContext";
import RestaurantsAccordion from "../../restaurants/restaurantsAccordion";
import MenuRestaurant from "./menuRestaurant";
import Separator from "../../spacers/separatorH";

// util imports
import {
	animationStates,
	fade,
	navMenuContainer,
} from "../../../utils/motionAnimations";

// svg imports

// component
export default function NavMenu() {
	const { t } = useTranslation();
	const { language, languages, originalPath } = useI18next();

	const { restaurantId, navMenuOpen, setNavMenuOpen } =
		React.useContext(LayoutContext);

	const webLinks = [
		{
			title: t("Reservar"),
			path: "/reserva",
		},
		{
			title: t("Locales y horarios"),
			path: "/ubicaciones",
		},
		{
			title: t("Sobre nosotros"),
			path: "/nosotros",
		},
		{
			title: t("Franquicia"),
			path: "/franquicia",
		},
	];

	const languageDisplay = {
		es: "ES",
		en: "EN",
		ja: "日本語",
	};

	const closeMenu = () => {
		setNavMenuOpen(false);
	};

	return (
		<AnimatePresence>
			{navMenuOpen && (
				<motion.div
					className="navMenuWrapper"
					key={navMenuOpen}
					{...animationStates}
					variants={{
						show: {
							transition: {
								when: "beforeChildren",
								staggerChildren: 0.075,
							},
						},
					}}
				>
					<motion.button
						className="navMenuBg"
						aria-label={t("Cerrar menú de navegación")}
						onClick={closeMenu}
						{...fade}
					/>
					<div
						className={`navMenuContainer padding ${restaurantId ? "marqueeSpace" : ""}`}
					>
						<motion.div {...navMenuContainer}>
							<RestaurantsAccordion component={MenuRestaurant} forceOpen />
						</motion.div>

						<motion.div {...navMenuContainer}>
							<div className="webLinks blurBg border">
								{webLinks.map(({ title, path }, i) => (
									<Fragment key={"webLink" + i}>
										{i !== 0 && <Separator />}
										<Link
											to={path}
											className="h3 padding invertOnHover"
											activeClassName="underline"
											onClick={closeMenu}
										>
											{title}
										</Link>
									</Fragment>
								))}
							</div>
						</motion.div>

						<motion.div {...navMenuContainer}>
							<div className="languages blurBg border">
								<div className="h3 padding">
									<Trans>Idioma</Trans>
								</div>
								{languages?.map((lng) => (
									<div
										key={lng}
										className={`${lng === language ? "active" : ""}`}
									>
										<Link
											to={originalPath}
											language={lng}
											className="h3 padding invertOnHover"
											onClick={closeMenu}
										>
											{languageDisplay[lng]}
										</Link>
									</div>
								))}
							</div>
						</motion.div>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
